import React, { useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import MoneyIcon from "@material-ui/icons/Money";
import * as Glob from "../../Globale";
import { Trad } from "../../components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _EconomicDataListTable, _InfoSection, _InfoTabs } from "../components";
import useTable from "../hooks/Table";

interface IRouteParam {
    ID_Anag: string;
    ID_FideAffidamento: string;
}

export const _EconomicDataList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const { ID_Anag, ID_FideAffidamento = "" } = useParams<IRouteParam>();
    const { Data, Options, IsLoading } = useTable(`/api/DatiEconomici/Ricerca?ID_Anag=${ID_Anag}`, {});

    const baseUrl = `/anagrafica/${ID_Anag}${ID_FideAffidamento ? `/fideaffidamento/${ID_FideAffidamento}` : ""}/DatiEconomici`;

    useEffect(() => {
        if (!Glob.AzioneAbilitata("DatiEconomiciController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }
    }, []);

    useEffect(() => {
        if (ID_FideAffidamento) {
            props.SetMenu({ ...Glob.GetMenu(), Main: "Affidamento", ID_MenuMain: 24, VariabiliMenu: { ["{ID_FideAffidamento}"]: ID_FideAffidamento } });
        }
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={MoneyIcon} Title="Dati economici">
                    {Glob.AzioneAbilitata("DatiEconomiciController", Glob.Scrittura) && (
                        <NavLink to={`${baseUrl}/0`}>
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <AddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )}
                </_PageTitle>
                <_MainContent WithPaper={false}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {ID_FideAffidamento ? (
                                <_InfoTabs ID_Anag={ID_Anag} ID_FideAffidamento={ID_FideAffidamento} />
                            ) : (
                                <_InfoSection DataUrl={`/api/anag/Contesto?ID_Anag=${ID_Anag}`} LinkUrl={`/anagrafica/${ID_Anag}`} Title="Anagrafica" />
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <_EconomicDataListTable BaseUrl={baseUrl} Data={Data} IsLoading={IsLoading} Options={Options} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/EconomicDataList.tsx